import { Box, useTheme } from "@mui/material";
import { useMemo } from "react";
import { useSpring, animated, easings } from "react-spring";

export const TableRowLoadingEffect = ({
  visible,
  rowWidth,
}: {
  visible: boolean;
  rowWidth: number;
}) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const color = isDarkMode ? "#ccc" : "#888";
  const { effectWidth } = useMemo(
    () => ({
      effectWidth: 0.2 * rowWidth,
    }),
    [rowWidth]
  );

  const [{ x, width }] = useSpring(() => ({
    from: {
      x: -effectWidth,
      width: effectWidth,
    },
    to: { x: rowWidth + effectWidth, width: effectWidth * 4 },
    loop: true,
    config: {
      duration: 1200,
      easing: easings.easeInCubic,
    },
  }));

  const Animated = animated.span as unknown as any;

  return (
    <Box
      component="td"
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: visible ? "block" : "none",
        opacity: 0.5,
        overflow: "hidden",
        width: "100%",
      }}
    >
      <Animated
        style={{
          x,
          position: "absolute",
          width,
          top: 0,
          bottom: 0,
          left: 0,
          right: "auto",
          background: `linear-gradient(to right, transparent 5%, ${color}, transparent 100%)`,
        }}
      />
    </Box>
  );
};
